export const environment = {
  // Reemplazar por tu clave real de Syncfusion (Essential Studio 34.x). No commitear en repos publicos.
  syncfusionLicenseKey: 'Ngo9BigBOggjHTQxAR8/V1JAaF5cX2pCd1p/TH5YfUNzdUVEY1ZUTXxaS1ZhSXxVdkxjWH9ecHNQQWdeVUF9XEY=',
  production: true,
  urlBackend: 'https://admin.sismat.com.ar',
  endpointBackend: 'https://admin.sismat.com.ar/api',
  urlExternalGateway: 'https://backend.sismat.com.ar',
  errorReportingUrl: 'https://sismat-errors-log-production.up.railway.app/errors',
  errorReportingApiKey: 'e7c7af6cb5e668a609e045d5b706656dd7dbfa23b289f740',
  gaCode: 'G-5XC5TXZ4GX',
  sentry: {
    environment: "production",
    dsn: "https://b26e6760a9544a558bfd453a9b57d9c6@o1185465.ingest.us.sentry.io/6304064",
    release: 'SISMAT-20261021'
  }
};
